// React
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";

// @mui material components
import { Card, Fade, Grid, Icon, Modal, Tooltip } from "@mui/material";

import { gql, useMutation } from "@apollo/client";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { MessageManager } from "context";
import dataAreas from "../data/dataAreas";
import SoftBox from "components/SoftBox";
import DataTable from "components/DataTable";
import SinDatos from "components/Carteles/SinDatos";
import ModalArea from "../ModalArea";
import { ConfirmarContext } from "context/ConfirmarContext";
import ModalMesa from "../../../mesas/ModalMesa";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "95%",
  width: { xs: "90%", sm: "80%", xxl: "80%" },
  overflowY: "auto",
  p: 3,
};

export default function ModalAdministrar({ open, handleClose, refetch, data, onAreaSaved }) {
  const { handleSnackbar } = useContext(MessageManager);
  const [rows, setRows] = useState([]);
  const [modalArea, setModalArea] = useState(false);
  const [modalMesa, setModalMesa] = useState(false);
  const [selectedArea, setSelectedArea] = useState(null);
  const { confirmar } = useContext(ConfirmarContext);

  const { columns, getRows } = dataAreas;

  const [deleteArea] = useMutation(
    gql`
      mutation deleteArea($id: ID!) {
        deleteArea(id: $id) {
          id
        }
      }
    `
  );

  useEffect(() => {
    if (data) {
      setRows(getRows(data, ejecutarAccionUsuario));
    }
  }, [data]);
  const ejecutarAccionUsuario = (accion, item) => {
    switch (accion) {
      case "editar":
        setModalArea(true);
        setSelectedArea(item);
        break;
      case "borrar":
        let areaOcupada = item.mesas.some((mesa) => mesa.estado !== "LIBRE");
        if (!areaOcupada) {
          confirmar({
            title: "Advertencia",
            message: "¿Está seguro que desea borrar? Esta acción no se puede deshacer.",
            icon: "warning",
            func: () => {
              deleteArea({ variables: { id: item.id } })
                .then(() => {
                  handleSnackbar("Borrado correctamente", "success");
                  refetch();
                })
                .catch(() => {
                  handleSnackbar("Ha ocurrido un error al borrar", "error");
                });
            },
          });
        } else {
          handleSnackbar("No se puede borrar un área con mesas ocupadas", "error");
        }
        break;
      default:
        break;
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <Grid container spacing={2}>
            <Grid item xs={12} display="flex" flexDirection="row" justifyContent="space-between">
              <SoftTypography variant="h6" align="center">
                Administrar Áreas
              </SoftTypography>
              <Grid>
                <Tooltip title="Cerrar" placement="top">
                  <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                    close
                  </Icon>
                </Tooltip>
              </Grid>
            </Grid>
            <Grid
              display={{
                xs: "flex-row",
                sm: "flex",
              }}
              justifyContent="end"
              alignItems="center"
              item
              xs={12}
            >
              <SoftBox
                mr={{
                  xs: 0,
                  sm: 2,
                }}
                mt={{
                  xs: 2,
                  sm: 0,
                }}
              >
                <SoftButton
                  color="primary"
                  circular
                  fullWidth={{
                    xs: true,
                    sm: false,
                  }}
                  onClick={() => {
                    setModalArea(true);
                  }}
                >
                  <Icon sx={{ fontWeight: "light" }}>zoom_out_map</Icon>
                  &nbsp;Nueva area
                </SoftButton>
              </SoftBox>
              <SoftBox
                mt={{
                  xs: 2,
                  sm: 0,
                }}
              >
                <SoftButton
                  color="uproGreen"
                  circular
                  fullWidth={{
                    xs: true,
                    sm: false,
                  }}
                  onClick={() => {
                    setModalMesa(true);
                  }}
                >
                  <Icon sx={{ fontWeight: "light" }}>table_restaurant</Icon>
                  &nbsp;Nueva Mesa
                </SoftButton>
              </SoftBox>
            </Grid>
          </Grid>
          <SoftBox>
            {rows?.length > 0 ? (
              <DataTable columns={columns} rows={rows} />
            ) : (
              <SinDatos
                titulo="No hay áreas"
                mensaje="No se encontraron áreas para mostrar, por favor, agrega una nueva."
                icono="zoom_out_map"
              />
            )}
          </SoftBox>
          <ModalArea
            open={modalArea}
            handleClose={() => {
              setModalArea(false);
              setSelectedArea(null);
            }}
            refetchAreas={refetch}
            selectedArea={selectedArea}
            onAreaSaved={onAreaSaved}
          />
          <ModalMesa
            open={modalMesa}
            handleClose={() => {
              setModalMesa(false);
            }}
            refetch={refetch}
            onAreaSaved={onAreaSaved}
          />
        </Card>
      </Fade>
    </Modal>
  );
}

ModalAdministrar.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  refetch: PropTypes.func,
  data: PropTypes.object,
  onAreaSaved: PropTypes.func,
};
